import React, {useEffect, useState} from 'react';
import FormHome from "../components/FormHome";
import EtapesProjet from "../components/EtapesProjet";
import {useParams, useLocation, useNavigate} from "react-router-dom";
import {API_URL} from "../config";

const VideosCorpo = () => {
    const {slug} = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const [projets, setProjets] = useState([]);

    // Récupère le dernier segment de l'URL si useParams ne marche pas
    const currentSlug = slug || location.pathname.split('/').filter(Boolean).pop();

    useEffect(() => {
        const fetchData = () => {
            fetch(`${API_URL}/videos/category/${currentSlug}?limit=2`)
                .then((res) => res.json())
                .then((data) => {
                    setProjets(data.videos || []);
                });
        };

        fetchData();

        const interval = setInterval(() => {
            fetchData();
        }, 5 * 60 * 1000);

        return () => clearInterval(interval);
    }, [currentSlug]);


    return(
        <>
            <div className="pb-32 pt-64 videos vertical-section">
                <div className="grid grid-cols-2 gap-x-14 mx-32">
                    <div className="publicitaires">
                        <h1 className="text-title-xl">Vidéos corporate</h1>
                        <p>
                            La vidéo corporate est aujourd’hui un levier essentiel pour valoriser votre entreprise, votre marque et votre savoir-faire.<br/><br/>
                            Chez Focus Production, entité du groupe Agence Le Menu, nous accompagnons les entreprises dans la création de vidéos corporate sur-mesure à Bordeaux et partout en France.<br/><br/>
                            Film institutionnel, interview, vidéo de présentation, contenu réseaux sociaux ou communication interne : nous imaginons des formats adaptés à vos objectifs, à votre audience et à votre image.

                        </p>
                    </div>
                    <div className="publicitaires">
                        <div className="line"></div>
                        <p>
                            Chaque projet est conçu pour transmettre le bon message, au bon format, avec une réalisation pensée pour marquer les esprits.
                        </p>
                    </div>
                </div>

                <div className="lesplus mx-32 mt-20 gap-x-20">
                    <div className="leplus-matos">
                        <h3>Matériel professionnel</h3>
                        <p>Nous utilisons du matériel audiovisuel professionnel afin de garantir une qualité d’image, de son et de production à la hauteur de votre communication.</p>
                    </div>

                    <div className="leplus-plus">
                        <h3>Un + pour votre entreprise</h3>
                        <p>L’objectif : créer des vidéos impactantes, capables de capter l’attention, renforcer votre image et valoriser durablement votre activité.</p>
                    </div>

                    <div className="leplus-bdx">
                        <h3>Proximité: <span>On est Bordelais !</span></h3>
                        <p>Basés à Bordeaux, nous privilégions une relation humaine, réactive et proche de nos clients, nous vous accompagnons à chaque étape avec une approche sur-mesure</p>
                    </div>
                </div>

            </div>

            <EtapesProjet/>

            <div className="autres px-32 py-16">
                <h2 className="font-bold text-f-40">Quelques réalisations<span>.</span></h2>
                <div className="autres-videos mt-8">
                    <div className="autres-videos-api">
                        {projets.map((projet) => (
                            <div className="card" key={projet.id}>
                                {projet.thumbnail ? (
                                    <img alt={projet.title} src={`${projet.thumbnail}`}/>
                                ) : (
                                    <div className="card-no-thumb">Pas d'aperçu</div>
                                )}
                                <h3 className="mt-2">{projet.title}</h3>
                                <p>{projet.description}</p>
                            </div>
                        ))}
                    </div>

                    <div className="autres-videos-bloc">
                        <p>Envie d'en voir plus ? </p>
                        <a onClick={() => navigate(`/realisations?cat=${currentSlug}`)} style={{cursor: 'pointer'}}>
                            Voir les réalisations
                        </a>
                    </div>


                </div>
            </div>

            <FormHome/>


    </>

    )
}

export default VideosCorpo